import BaseService from '@/api/services/BaseService';

const API_RESOURCE = 'sms/settings';

export default class SettingsService extends BaseService {
  static getSettings() {
    const URI = `${API_RESOURCE}/${this.encodedUserId}`;
    return this.getRequest(URI).then(([settings]) => settings);
  }

  static setSettings(newSettings) {
    const URI = `${API_RESOURCE}/${this.encodedUserId}`;
    return this.postRequest(URI, newSettings);
  }
}
